<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">

            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================-->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Vorversicherung</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Geben Sie hier an, ob eine Vorversicherung für das zu versichernde Gebäude besteht oder bestanden hat.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vorvers_jn"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <template v-if="value.fieldValues.vorvers_jn==1">
                    <v-layout row>
                        <Rechner-hint-col>
                            Geben Sie hier den Namen der Gesellschaft / Versicherung an.
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs.vorvers_versicherer" v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Geben Sie hier die Versicherungsscheinnummer / Vertragsnummer an.
                        </Rechner-hint-col>
                        <v-flex xxx class="xs10">
                            <Rechner-field-col :fielddef="fieldDefs.vorvers_versnr" v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Bis wann besteht Ihre bisherige Versicherung bzw. zu welchem Termin endet diese?
                        </Rechner-hint-col>
                        <v-flex xxx class="xs10">
                            <Rechner-field-col :fielddef="fieldDefs.vorvers_bis" v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Wie viele Vorschäden wurden in den letzten {{$store.state.rechnerConfig.rechnerInfo.vorschaden_max_jahre}} ahren gemeldet?
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs.vorvers_vorschaden_anzahl"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Welche Gesamtentschädigung wurde für die gemeldeten Vorschäden gezahlt?
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs.vorvers_vorschaden_summe"
                                               v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row v-if="value.fieldValues.vorvers_vorschaden_anzahl > 0">
                        <v-flex xs1 class=" mr-2">
                            <div>
                                <v-icon medium class="mt-3 orange--text" style="margin: -5px 0 10px 0 !important;"
                                        floating>info
                                </v-icon>
                            </div>
                        </v-flex>
                        <v-flex xs10>
                            auf Grund der angegebenen Vorschäden wird die Annahme des Antrages geprüft.
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                </template>

            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import slideMixin from '../stepMixin'
    import _ from 'lodash'

    //import {mapState} from 'vuex'

    export default {
        //========================================================================================================
        data: function () {

            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}

            return {
                fieldDefs: fieldDefs_OVERRIDE,


            }
        }, //========================================================================================================
        name: 'Step_VorVers',
        label: 'Vorversicherung',
        fieldKeys: [
            'vorvers_jn',
            'vorvers_versicherer',
            'vorvers_versnr',
            'vorvers_bis',
            'vorvers_vorschaden_anzahl',
            'vorvers_vorschaden_summe',
            'vertrag_sparte',
        ],
        //========================================================================================================
        watch: {

            value: {
                handler: function (newVal, oldVal) {
                    //this.value.fieldValues.xxx = "TEST"
                    console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
                    console.log("WATCHER fieldValues in ", this.$options.label)
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld
                    var earlyExit = true;
                    for (var key in fV) {
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            console.log("changed ", key, fVold[key], '->', fV[key])
                        }
                    }
                    if (earlyExit === true) {
                        console.log("NO changes -> early EXIT")
                        return;
                    }

                    //----------------------------------------------------------------------------
                    if (parseInt(fV.vorvers_jn, 10) === 0 && fVold.vorvers_jn !== fV.vorvers_jn) {
                        this.value.fieldValues.vorvers_versicherer = '-/-';
                        this.value.fieldValues.vorvers_versnr = '-/-';
                        this.value.fieldValues.vorvers_bis = '01.01.1900';
                        this.value.fieldValues.vorvers_vorschaden_anzahl = '-/-';
                        this.value.fieldValues.vorvers_vorschaden_summe = '-/-';
                        console.log(fV.woge_jn_gewerbeeinheit, ' -> diasble prozent & name ')
                        console.log("WATCHER: update  vorVers: OFF -> set all to -/-")
                    }
                    if (parseInt(fV.vorvers_jn, 10) === 1 && fVold.vorvers_jn !== fV.vorvers_jn) {
                        this.value.fieldValues.vorvers_versicherer = null;
                        this.value.fieldValues.vorvers_versnr = null;
                        this.value.fieldValues.vorvers_bis = null;
                        this.value.fieldValues.vorvers_vorschaden_anzahl = null;
                        this.value.fieldValues.vorvers_vorschaden_summe = null;
                        console.log("WATCHER: update  vorVers: ON -> set all to NULL")
                    }
                    //----------------------------------------------------------------------------
                    this.frmValuesOld = _.assign({}, fV)

                },
                deep: true,

            }
            ,
        }, //===============================================================================================
        mixins: [slideMixin],
        //===========================================================================================================
        components: {
            /* programmatically setted by step-mixin*/
        }, //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        // HOOKS:
        /* programmatically setted by step-mixin*/
        //===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
